import React, { Component } from "react";
import { Button, Form, Icon, Modal } from "semantic-ui-react";
import "scss/components/modals/deviceData/pairDeviceModal.scss";

export default class PairDeviceModal extends Component {
  render() {
    const deviceDetail = this.props.data;
    return (
      <Modal
        closeIcon
        dimmer="blurring"
        open={this.props.isOpen}
        onClose={() => this.props.isClose()}
      >
        <Modal.Header>
          <Icon name="archive" />
          &ensp;ข้อมูลเครื่องจักร
        </Modal.Header>
        <Modal.Content className="pair">
          <table>
            <tbody>
              <tr>
                <td>หมายเลขเครื่องจักร</td>
                <td>
                  <Form.Input
                    placeholder="หมายเลขเครื่องจักร"
                    value={deviceDetail.name}
                  />
                </td>
              </tr>
              <tr>
                <td>หมายเลขอุปกรณ์ IoT</td>
                <td>
                  <Form.Input
                    placeholder="หมายเลขอุปกรณ์ IoT"
                    value={deviceDetail.iotSerial}
                    readOnly
                  />
                </td>
              </tr>
              <tr>
                <td>รุ่นของเครื่องจักร</td>
                <td>
                  <Form.Input
                    placeholder="รุ่นของเครื่องจักร"
                    value={deviceDetail.model}
                  />
                </td>
              </tr>
              <tr>
                <td>ยี่ห้อมอเตอร์ไฟฟ้า</td>
                <td>
                  <Form.Input
                    placeholder="รุ่นของเครื่องจักร"
                    value={deviceDetail.motorBrand}
                  />
                </td>
              </tr>
              <tr>
                <td>รุ่นมอเตอร์ไฟฟ้า</td>
                <td>
                  <Form.Input
                    placeholder="รุ่นของเครื่องจักร"
                    value={deviceDetail.motor}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </Modal.Content>
        {/* <Modal.Actions>
          <Button basic negative onClick={() => this.props.isClose()}>
            ยกเลิก
          </Button>
          <Button color="twitter" onClick={() => this.props.isClose()}>
            บันทึก
          </Button>
        </Modal.Actions> */}
      </Modal>
    );
  }
}
